import React, { ReactNode, FC, useContext } from 'react';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';
import ColorSchemeContext from '../../colorScheme/ColorSchemeContext';
import { StyledTitle } from './T2.styles';

export interface T2Props extends SCP<'h3'> {
  /** Content of the title. */
  children?: ReactNode;
  /** Alignement of the text­. */
  align?: 'left' | 'center' | 'right';
  /** Margin top. */
  marginTop?: number;
  /** Margin bottom. */
  marginBottom?: number;
}

const T2DefaultProps = {
  marginTop: 0,
  marginBottom: 28,
};

/**
 * @since 0.18.0
 */
const T2: FC<T2Props> = ({ marginBottom, marginTop, align, ...props }) => {
  const { scheme } = useContext(ColorSchemeContext);

  return (
    <StyledTitle
      data-testid="T2"
      $darkened={scheme === COLOR_SCHEMES.DARK}
      $marginTop={marginTop}
      $marginBottom={marginBottom}
      $align={align}
      {...props}
    />
  );
};

T2.defaultProps = T2DefaultProps;

/** @component */
export default T2;
